import { Component } from '@angular/core';

@Component({
    selector: "ngx-footer",
    styleUrls: ["./footer.component.scss"],
    template: `
        <img class="created-by" src="assets/images/logota.png" />
        <div class="socials">
            <!--<a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>-->
        </div>
        <div class="policies">
            <a href="/cookie-policy" target="_blank">COOKIE POLICY</a> |
            <a href="/privacy-policy" target="_blank">PRIVACY POLICY</a> |
            <a href="/questionario_1_3" target="_blank">QUESTIONARIO_1_3</a> |
            <a href="/questionario" target="_blank">QUESTIONARIO_2_4</a>
        </div>
    `,
})
export class FooterComponent {}
